var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "block--article  block--light block--listed"
  }, [_c('a', {
    staticClass: "inner  block--long block--arrow-right block--padding-30",
    attrs: {
      "href": _vm.postdata.slug
    }
  }, [_c('span', {
    staticClass: "screen-reader-text"
  }, [_vm._v("(Open post)")]), _vm._v(" "), _c('div', {
    staticClass: "meta post-meta"
  }, [_c('ul', {
    staticClass: "category--list"
  }, _vm._l((_vm.postdata.cat_names), function(catname) {
    return _c('li', {
      key: catname,
      staticClass: "cat"
    }, [_vm._v("\n                    " + _vm._s(catname) + "\n                    "), _c('span', {
      staticClass: "sep"
    }, [_vm._v(",")])])
  })), _vm._v(" "), _c('time', {
    staticClass: "piblish",
    attrs: {
      "datetime": _vm.postdata.post_date
    }
  }, [_vm._v(_vm._s(_vm.postDate))])]), _vm._v(" "), _c('h3', {
    staticClass: "text--300 titler titler",
    domProps: {
      "innerHTML": _vm._s(_vm.postdata.title)
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1916d460","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/components/postBlock.vue
// module id = 207
// module chunks = 0